import { convertPhToISODate } from '~shared/lib/convert-date';

import type {
  Agent,
  ApplicationData,
  PartnerApplicationContext,
} from '../../model';

export function formatAgents(
  data: ApplicationData,
  values: Partial<PartnerApplicationContext>['agents']
): ApplicationData {
  if (!values?.length) return { ...data, agents: [] };

  const agents: Agent[] = values.map((agent) => ({
    uiId: agent.uiId,
    firstName: agent.firstName,
    middleName: agent.middleName,
    lastName: agent.lastName,
    birthDate: convertPhToISODate(agent.birthDate),
    email: agent.email,
    mobilePhone: agent.mobilePhone,
    assignedPointsOfSales: agent.assignedPointsOfSales,
  }));

  return { ...data, agents };
}
